import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import {
  GetReceivedMethod,
  GetRelationshipMaster,
  GetUrgencyStatusMaster,
  SavePatientInformationData,
  UpdateRemovePatient,
} from "../services/Patient";
import { ApplicationState } from "../store/ApplicationState";
import {
  RelationshipDispatchTypes,
  RemovePatientDispatchTypes,
  SavePatientInformationDispatchTypes,
  ReceivedMethodDispatchTypes,
  UrgencyStatusDispatchTypes,
  PriorAuthReceivedMethodDispatchTypes,
} from "../models/DispatchTypes/Patient";
import {
  RelationshipActionDispatchTypes,
  RemovePatientActionDispatchTypes,
  SavePatientInformationActionDispatchTypes,
  ReceivedMethodActionDispatchTypes,
  UrgencyStatusActionDispatchTypes,
  PriorAuthReceivedMethodActionDispatchTypes,
} from "../constants/Patient";
import { configUrlForReferral } from "../constants/Config";
import { MessageType, ReferralResponseMessages } from "../constants/AllPatientRecord";
import SnackbarUtils from "../utils/SnackbarProvider";
import { updateLastSyncDateInStorage } from "../utils";
import { ServiceRequestType } from "../constants/Master";
import { DataPresentInLocalStorage } from "../constants/Constants";

export const SavepatientInformationCall: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    SavePatientInformationDispatchTypes
  >
> = (data: FormData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: SavePatientInformationActionDispatchTypes.SAVE_PATIENT_INFORMATION_INVOKE,
    });
    const response = await SavePatientInformationData(
      configUrlForReferral,
      data
    );

    if (response && response.status) {
          switch (response.status) {
            case 422:
            case 400:
            case 404:
              dispatch({
                error: response.data,
                type: SavePatientInformationActionDispatchTypes.SAVE_PATIENT_INFORMATION_ERROR,
              });
              break;
            case 200:
            case 201:
              dispatch({
                response: response.data,
                type: SavePatientInformationActionDispatchTypes.SAVE_PATIENT_INFORMATION_SUCCESS,
              });
              break;
            default:
              break;
          }
        }
  };
};

export const getReceivedMethodMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReceivedMethodDispatchTypes
  >
> = (serviceRequestTypeId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReceivedMethodActionDispatchTypes.GET_RECEIVED_METHOD_INVOKE,
    });
    const response = await GetReceivedMethod(
      configUrlForReferral,
      serviceRequestTypeId
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ReceivedMethodActionDispatchTypes.GET_RECEIVED_METHOD_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ReceivedMethodActionDispatchTypes.GET_RECEIVED_METHOD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getPriorAuthReceivedMethodMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PriorAuthReceivedMethodDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_SUCCESS,
      GetReceivedMethod,
      configUrlForReferral,
      ServiceRequestType.AUTH_ID
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_ERROR,
          });
          break;
        case 200:
          dispatch({
            response:response.data,
            type: PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response:response.data,
        type: PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_SUCCESS,
      });
    }

  };
};

//urgency status
export const getUrgencyStatusMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    UrgencyStatusDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS,
      GetUrgencyStatusMaster,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS,
      });
    }
  };
};

//relationship
export const getRelationshipMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    RelationshipDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RelationshipActionDispatchTypes.GET_RELATIONSHIP_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      RelationshipActionDispatchTypes.GET_RELATIONSHIP_SUCCESS,
      GetRelationshipMaster,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: RelationshipActionDispatchTypes.GET_RELATIONSHIP_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: RelationshipActionDispatchTypes.GET_RELATIONSHIP_SUCCESS,
          });
          break;
        default:
          break;
      }
    }else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: RelationshipActionDispatchTypes.GET_RELATIONSHIP_SUCCESS,
      });
    }
  };
};

export const updateRemovePatient: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    RemovePatientDispatchTypes
  >
> = (payload: any, staffId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RemovePatientActionDispatchTypes.REMOVE_PATIENT_INVOKE,
    });
    const response = await UpdateRemovePatient(
      configUrlForReferral,
      payload,
      staffId
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            response,
            type: RemovePatientActionDispatchTypes.REMOVE_PATIENT_ERROR,
          });
          SnackbarUtils.error(
            ReferralResponseMessages(MessageType.REMOVE_PATIENT_ERROR)
          );
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: RemovePatientActionDispatchTypes.REMOVE_PATIENT_SUCCESS,
          });
          SnackbarUtils.success(
            ReferralResponseMessages(MessageType.REMOVE_PATIENT_SUCCESS)
          );
          break;
        default:
          break;
      }
    }
  };
};
